import { Flex } from '../../../summary/components/Flex.js';
import { PDFOnly } from '../../../summary/components/PDFOnly.js';
import { Typography } from '../../../summary/components/Typography.js';
import { WebOnly } from '../../../summary/components/WebOnly.js';
import { SummarySection } from '../SummarySection.js';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.js';
import { CostApproachManufacturedSummaryTable } from './CostApproachManufacturedSummaryTable.js';
import { CostApproachSummaryCommentary } from './CostApproachSummaryCommentary.js';
import { CostApproachSummarySource } from './CostApproachSummarySource.js';
import { CostApproachSummaryTable } from './CostApproachSummaryTable.js';
import { COST_APPROACH_SITE_COMMENT, getCostApproachReplacementCostComment } from './consts.js';

export const CostApproachSummary = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const isManufactured = props.orderInput?.propertyType === 'manufacturedHome';

  return (
    <SummarySection shouldBreak={false}>
      <TitleAndExportToggleLockup
        {...props}
        title="Cost Approach to Value"
        id="isCostApproachCommentaryInExport"
        commentary={props.exportableCommentaries.costApproach}
      />
      <Typography variant="body1">{COST_APPROACH_SITE_COMMENT}</Typography>
      <Flex height="1rem" />
      <Typography variant="body1">
        {getCostApproachReplacementCostComment(
          props.results.subject?.totals?.costApproach?.source.name ?? 'Craftsman',
        )}
      </Typography>
      <PDFOnly>
        <Typography variant="body1">
          {props.exportableCommentaries.costApproach.commentary}
        </Typography>
      </PDFOnly>
      {isManufactured ? (
        <CostApproachManufacturedSummaryTable {...props} />
      ) : (
        <CostApproachSummaryTable {...props} />
      )}
      <CostApproachSummarySource
        source={props.results.subject?.totals?.costApproach?.source}
        quality={props.results.subject?.features.quality?.dwellingCostQuality}
        {...props}
        physicalDepreciation={
          props.subject.costDataExtension.depreciation?.physicalDepreciation?.primaryDwelling
        }
      />
      <WebOnly>
        <CostApproachSummaryCommentary costApproach={props.exportableCommentaries.costApproach} />
      </WebOnly>
    </SummarySection>
  );
};
